const TermsOfUse = () => (
  <div className="px-[100px] py-[32px] md:px-[16px] md:pb-4">
    <h1 className="text-3xl font-bold mb-8">Terms of Use</h1>
    <p className="text-base mb-4">
      Omya and its Affiliates CES Mobile App Terms of Use and Legal
      Restrictions.
    </p>
    <h2 className="text-black text-xl font-bold mb-4">Use of App</h2>
    <p className="text-base mb-4">
      Omya and its affiliates (&quot;Omya&quot;) authorize you to view and
      download the materials from this App (&quot;Site&quot;), provided that you
      retain all copyright and other proprietary notices contained in the
      original materials or on any copies of the materials.
    </p>
    <h2 className="text-black text-xl font-bold mb-4">Disclaimer</h2>
    <p className="text-base mb-4">
      The materials provided at this site are provided &quot;as is&quot; without
      any warranties of any kind including warranties of merchantability,
      fitness for a particular purpose or of any other nature regarding the
      information presented in this site, or non-infringement of intellectual
      property.
    </p>
    <p className="text-base mb-4">
      Omya further does not warrant the accuracy or completeness of the
      materials presented at this Site or use of any information or product
      presented herein. Omya may make changes to the materials at this Site, or
      to the products and prices described in them, at any time without notice.
      You must make your own determination as to the suitability, accuracy or
      completeness of the information for your own use, for the protection of
      the environment and for health and safety purposes.
    </p>
    <h2 className="text-black text-xl font-bold mb-4">
      Limitation of Liability
    </h2>
    <p className="text-base mb-4">
      In no event shall omya and its affiliates, its suppliers, or other third
      parties mentioned at this site be responsible for any liability or damages
      whatsoever including, without limitation, those resulting from lost
      profits, consequential or incidental damages, lost data or business
      interruption arising out of the use, inability to use, or the results of
      use of this site or the information contained in any web sites linked to
      this site, or the materials or information contained at any or all such
      sites, whether based on warranty, contract, tort or any other legal theory
      and whether or not advised of the possibility of such damages. If the use
      of the materials or information from this site results in the need for
      servicing, repair or correction of equipment or data, you assume all costs
      thereof.
    </p>
    <h2 className="text-black text-xl font-bold mb-4">General</h2>
    <p className="text-base mb-4">
      Omya may revise these Terms at any time by updating this posting. You
      should visit this page from time to time to review the up-to-date Terms as
      these are binding for you. Certain provisions of these Terms may be
      superseded by expressly designated legal notices or terms located on
      particular pages at this Site.
    </p>
  </div>
);

export default TermsOfUse;
